// ============================================================================
// SYSTEM CONFIGURATION SERVICE
// ============================================================================

import { get, put } from '../client/axiosClient';
import { systemConfigEndpoints } from '../endpoints/systemConfig.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  SystemConfig,
  UpdateSystemConfigRequest,
  SystemConfigFilterParams,
} from '../types/systemConfig.types';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';

class SystemConfigService {
  async getAll(params?: SystemConfigFilterParams): Promise<PaginatedResponse<SystemConfig>> {
    const endpoint = params
      ? buildEndpointWithQuery(systemConfigEndpoints.list(), params)
      : systemConfigEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<SystemConfig>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<SystemConfig>> {
    const response = await get<ApiResponse<SystemConfig>>(systemConfigEndpoints.getById(id));
    return response.data;
  }

  async update(id: ID, data: UpdateSystemConfigRequest): Promise<ApiResponse<SystemConfig>> {
    const response = await put<ApiResponse<SystemConfig>>(systemConfigEndpoints.update(id), data);
    return response.data;
  }
}

export const systemConfigService = new SystemConfigService();
export default systemConfigService;
